export const messages = {
  en: {
    shopIntegral: {
      title: 'Shop Points',
      accountId: 'Account ID:',
      accountName: 'Account Name:',
      accountBalance: 'Account Balance:',
      withdraw: 'Withdraw',
      transactionDetails: 'Transaction Details',
      pointsWithdrawal: 'Points Withdrawal'
    },
    shopIntegralDetail: {
      serialNumber: 'No.',
      pointsAccount: 'Points Account',
      type: 'Type',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out',
      transactionAmount: 'Transaction Amount',
      currentAmount: 'Current Amount',
      transactionNumber: 'Transaction No.',
      remark: 'Remark',
      time: 'Time'
    },
    applyWithholdIntegral: {
      serialNumber: 'No.',
      pointsId: 'Points ID',
      pointsName: 'Points Name',
      shopNumber: 'Shop No.',
      withdrawalAmount: 'Withdrawal Amount',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      bankAccount: 'Bank Account',
      accountName: 'Account Name',
      openingBank: 'Opening Bank',
      applicationNote: 'Application Note',
      status: 'Status',
      reviewNote: 'Review Note',
      operation: 'Operation',
      delete: 'Delete'
    },
    deleteApplyWithholdIntegral: {
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteApplication: 'Confirm to delete the application?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    },
    withholdIntegral: {
      applyWithdrawal: 'Apply Withdrawal',
      totalPoints: 'Total Points',
      requiredTotalPoints: 'Required, please enter total points',
      withdrawalPoints: 'Withdrawal Points',
      requiredWithdrawalPoints: 'Required, please enter withdrawal points',
      applicant: 'Applicant',
      requiredApplicant: 'Required, please enter applicant',
      applicantPhone: 'Applicant Phone',
      requiredApplicantPhone: 'Required, please enter applicant phone',
      bankAccount: 'Bank Account',
      requiredBankAccount: 'Required, please enter bank account',
      accountName: 'Account Name',
      requiredAccountName: 'Required, please enter account name',
      openingBank: 'Opening Bank',
      requiredOpeningBank: 'Required, please enter opening bank',
      applicationNote: 'Application Note',
      requiredApplicationNote: 'Required, please enter application note',
      cancel: 'Cancel',
      submit: 'Submit',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed'
    }
  },
  zh: {
    shopIntegral: {
      title: '店铺积分',
      accountId: '账户ID：',
      accountName: '账户名称：',
      accountBalance: '账户余额：',
      withdraw: '提现',
      transactionDetails: '交易明细',
      pointsWithdrawal: '积分提现'
    },
    shopIntegralDetail: {
      serialNumber: '编号',
      pointsAccount: '金币账户',
      type: '类型',
      transferIn: '转入',
      transferOut: '转出',
      transactionAmount: '交易金额',
      currentAmount: '当前金额',
      transactionNumber: '交易单号',
      remark: '备注',
      time: '时间'
    },
    applyWithholdIntegral: {
      serialNumber: '编号',
      pointsId: '积分ID',
      pointsName: '积分名称',
      shopNumber: '商铺编号',
      withdrawalAmount: '提现金额',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      bankAccount: '银行账户',
      accountName: '账号名称',
      openingBank: '开户行',
      applicationNote: '申请说明',
      status: '状态',
      reviewNote: '审核说明',
      operation: '操作',
      delete: '删除'
    },
    deleteApplyWithholdIntegral: {
      confirmOperation: '请确认您的操作！',
      confirmDeleteApplication: '确定删除申请？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    withholdIntegral: {
      applyWithdrawal: '申请提现',
      totalPoints: '总积分数',
      requiredTotalPoints: '必填，请填写总积分数',
      withdrawalPoints: '提现积分',
      requiredWithdrawalPoints: '必填，请填写提现积分',
      applicant: '申请人',
      requiredApplicant: '必填，请填写申请人',
      applicantPhone: '申请人电话',
      requiredApplicantPhone: '必填，请填写申请人电话',
      bankAccount: '银行账户',
      requiredBankAccount: '必填，请填写银行账户',
      accountName: '账号名称',
      requiredAccountName: '必填，请填写账号名称',
      openingBank: '开户行',
      requiredOpeningBank: '必填，请填写开户行',
      applicationNote: '申请说明',
      requiredApplicationNote: '必填，请填写申请说明',
      cancel: '取消',
      submit: '提交',
      submitSuccess: '提交成功',
      submitFailed: '提交失败'
    }
  }
}